module.exports = __webpack_public_path__ + "img/badatong-mobile.6a0c28a5.png";